import { OnStartRender } from 'rcx_adapter';
import type { SecondIframeState } from '../constants';
import type { SecondIframeInfo } from './types';

export enum GlobalActionTypes {
    ChangeSecondIframeState = '@rcx/ChangeSecondIframeState',
    ResetSecondIframeState = '@rcx/ResetSecondIframeState',
    // script
    SetScriptUrl = '@rcx/SetScriptUrl',
    UpdateScriptUrlTimeStamp = '@rcx/UpdateScriptUrlTimeStamp',
    SetSecondIframeScript = '@rcx/SetSecondIframeScript',
    UpdateSecondIframeScript = '@rcx/UpdateSecondIframeScript',
    UpdateSecondIframeLoading = '@rcx/UpdateSecondIframeLoading',
    // digital
    SetSecondIframeDigital = '@rcx/SetSecondIframeDigital',
}

export function setScriptUrl(payload: string) {
    return {
        type: GlobalActionTypes.SetScriptUrl,
        payload,
    };
}

export function updateScriptUrlTimeStamp() {
    return {
        type: GlobalActionTypes.UpdateScriptUrlTimeStamp,
    };
}

export function changeSecondIframeState(payload: SecondIframeState) {
    return {
        type: GlobalActionTypes.ChangeSecondIframeState,
        payload,
    };
}

export function resetSecondIframeState() {
    return {
        type: GlobalActionTypes.ResetSecondIframeState,
    };
}

export function setSecondIframeScript(payload: OnStartRender | null) {
    return {
        type: GlobalActionTypes.SetSecondIframeScript,
        payload,
    };
}

export function updateSecondIframeScript(
    payload: Pick<SecondIframeInfo, 'renderId' | 'pending' | 'submitted' | 'isEnd' | 'scriptId'>
) {
    return {
        type: GlobalActionTypes.UpdateSecondIframeScript,
        payload,
    };
}

export function updateSecondIframeLoading(payload: boolean) {
    return {
        type: GlobalActionTypes.UpdateSecondIframeLoading,
        payload,
    };
}

export function setSecondIframeDigital(payload: OnStartRender | null) {
    return {
        type: GlobalActionTypes.SetSecondIframeDigital,
        payload,
    };
}
